import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'Features/App/store';
import App from 'Features/App/App';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';

// const App = React.lazy(() => import('Components/App'));

ReactDOM.render(
  // 16.10.2020
  // <React.StrictMode>
  <Suspense fallback={null}>
    <Provider store={store}>
      <App />
    </Provider>
  </Suspense>,
  /* </React.StrictMode>, */
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
